import BottomSheet from "@gorhom/bottom-sheet";
import { Portal } from "@gorhom/portal";
import React, { useCallback, useEffect, useRef } from "react";
import { useWindowDimensions } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useTheme } from "../../hooks";
import { BottomSheetBackdrop } from "../shared";
import { BookmarkList } from "./BookmarkList";
export const BookmarkModal = ({ item, closeModal, closeParentModal, isOpen, editItem, }) => {
    const { top } = useSafeAreaInsets();
    const { height } = useWindowDimensions();
    const safeMaxSnapPoint = `${(1 - top / height) * 100}%`;
    const { colors } = useTheme();
    const bottomSheetRef = useRef(null);
    const handleSheetChanges = useCallback((index) => {
        if (index < 0) {
            closeModal();
        }
    }, []);
    useEffect(() => {
        if (isOpen !== true) {
            return;
        }
        if (editItem) {
            bottomSheetRef.current?.snapToPosition(1);
        }
        else {
            bottomSheetRef.current?.snapToPosition(0);
        }
    }, [isOpen]);
    return (React.createElement(Portal, null,
        React.createElement(BottomSheet, { ref: bottomSheetRef, backdropComponent: BottomSheetBackdrop, index: 0, topInset: top, enablePanDownToClose: true, enableDynamicSizing: false, animateOnMount: true, snapPoints: [safeMaxSnapPoint], onChange: handleSheetChanges, backgroundStyle: { backgroundColor: colors.backgroundPrimary }, handleIndicatorStyle: { backgroundColor: colors.textPrimary }, containerStyle: { zIndex: 4000 } },
            React.createElement(BookmarkList, { initialEditItem: editItem, content: item, closeModal: () => {
                    bottomSheetRef.current?.close();
                    closeParentModal && closeParentModal();
                } }))));
};
//# sourceMappingURL=BookmarkModal.js.map